"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.excludeNextjsTelemetryProcessor = void 0;
/**
 * Excludes Next.js telemetry from the given envelope.
 *
 * @param envelope The telemetry envelope to process.
 * @returns A boolean indicating whether the telemetry should be excluded.
 */
const excludeNextjsTelemetryProcessor = envelope => {
  // Next.js telemetry always contains this property
  if ('next.span_type' in envelope.data.baseData?.properties) {
    return false;
  }
  return true;
};
exports.excludeNextjsTelemetryProcessor = excludeNextjsTelemetryProcessor;
